<div class="title">
    {{ "catalog_general_settings_card" | translate | uppercase }}
</div>

<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_background_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="backgroundColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setThemeBackgroundColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-6 control-label">
            {{ "control_radius" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                prefixImgUrl="./assets/img/border-radius-icon.svg"
                suffixText="px"
                [min]="BORDER_RADIUS_MIN"
                [max]="BORDER_RADIUS_MAX"
                [onlyIntegers]="true"
                [value]="borderRadius.value"
                (valueChange)="setBorderRadius($event)"
                (blurEvent)="setBorderRadius($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-7 control-label">
            {{ "control_padding" | translate }}
        </label>
        <div class="col-xs-5">
            <sp-input-num
                suffixText="px"
                [min]="PADDING_MIN"
                [max]="PADDING_MAX"
                [onlyIntegers]="true"
                [value]="padding.value"
                (valueChange)="setPadding($event)"
                (blurEvent)="setPadding($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group" [class.mb-10]="isBorder.value" [class.mb-0]="!isBorder.value">
        <label class="col-xs-9 control-label">
            {{ "control_contour" | translate }}
        </label>
        <div class="col-xs-3 text-right">
            <sp-switch [control]="isBorder"></sp-switch>
        </div>
    </div>

    @if (isBorder.value) {
        <div class="form-group mb-0">
            <div class="col-xs-4">
                <sp-input-num
                    suffixText="px"
                    [min]="SIZE_MIN"
                    [max]="SIZE_MAX"
                    [onlyIntegers]="true"
                    [value]="+borderWidth.value"
                    (valueChange)="setBorderWidth($event)"
                ></sp-input-num>
            </div>
            <div class="col-xs-6">
                <select class="form-control" [formControl]="borderStyle">
                    <option [ngValue]="lineStyle.SOLID">{{ "control_solid" | translate }}</option>
                    <option [ngValue]="lineStyle.DASHED">{{ "control_dashed" | translate }}</option>
                    <option [ngValue]="lineStyle.DOTTED">{{ "control_dotted" | translate }}</option>
                </select>
            </div>
            <div class="col-xs-2">
                <sp-color-picker
                    [color]="borderColor.value?.toString()"
                    (colorChangeEvent)="setBorderColor($event)"
                    [hideGradient]="true"
                ></sp-color-picker>
            </div>
        </div>
    }

    <div class="form-group mb-0">
        <div class="col-xs-12">
            <hr class="panel-options-divider" />
        </div>
    </div>
</div>
